import {NzNotificationService} from 'ng-zorro-antd/notification';
import {VssAdminService} from './services/vss-admin.service';
import {VssUiConfig} from './vss-ui.model';
import {NzMessageService} from 'ng-zorro-antd/message';

export const vssProviders = [
  NzNotificationService,
  VssAdminService,
  VssUiConfig,
  NzMessageService
]
